module.exports = __webpack_public_path__ + "files/81470f23bc02ee8106d1ebd539f53147.png";